/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const People = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 5.5C10 7.433 8.433 9 6.5 9C4.567 9 3 7.433 3 5.5C3 3.567 4.567 2 6.5 2C8.433 2 10 3.567 10 5.5ZM8.5 5.5C8.5 6.60457 7.60457 7.5 6.5 7.5C5.39543 7.5 4.5 6.60457 4.5 5.5C4.5 4.39543 5.39543 3.5 6.5 3.5C7.60457 3.5 8.5 4.39543 8.5 5.5ZM21 5.5C21 7.433 19.433 9 17.5 9C15.567 9 14 7.433 14 5.5C14 3.567 15.567 2 17.5 2C19.433 2 21 3.567 21 5.5ZM19.5 5.5C19.5 6.60457 18.6046 7.5 17.5 7.5C16.3954 7.5 15.5 6.60457 15.5 5.5C15.5 4.39543 16.3954 3.5 17.5 3.5C18.6046 3.5 19.5 4.39543 19.5 5.5ZM3.5 14.5C3.5 12.8431 4.84315 11.5 6.5 11.5C8.15685 11.5 9.5 12.8431 9.5 14.5V19H11V14.5C11 12.0147 8.98528 10 6.5 10C4.01472 10 2 12.0147 2 14.5V22H2.5H3.5H13H14.5V20.5V14.5C14.5 12.8431 15.8431 11.5 17.5 11.5C19.1569 11.5 20.5 12.8431 20.5 14.5V20.5H16V22H20.5H21.5H22V14.5C22 12.0147 19.9853 10 17.5 10C15.0147 10 13 12.0147 13 14.5V20.5H3.5V14.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
